export default __webpack_public_path__ + "static/middleby-39f1c863cb2497e99f597cd67dae75ad.png";